const initialThirdPerson = {
  name: 'Nicky de Saint Phalle',
  artwork: {
    title: 'Blue Nana',
    city: 'Hamburg',
    image: 'https://i.imgur.com/Sd1AgUOm.jpg',
  },
};

export { initialThirdPerson };
